import React from 'react';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import CommonContainer from "../../containers/Common";

interface Props {
  makerCode: string | undefined,
  onChange: (makerCode: string) => void,
}

export default ((props) => {

  const commonContainer = CommonContainer.useContainer();
  const makerCode = props.makerCode || commonContainer.makers[0].makerCode;

  const handleChange = (value: string) => {
    if (props.makerCode !== value) {
      props.onChange(value);
    }
  };

  return (
    <Select style={{ fontSize: 13, }} required fullWidth name='maker' label='Maker' id='maker' value={makerCode} onChange={(event) => handleChange(event.target.value as string)}>
      {commonContainer.makers.map(maker => (
        <MenuItem key={maker.makerCode} value={maker.makerCode}>{maker.makerName}</MenuItem>)
      )}
    </Select>
  );
}) as React.FC<Props>;
